// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".input__error[data-v-2406620f]{font-size:1.5rem;color:#D0011B}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
